import React, { useState, useEffect } from "react";
import {
  Dialog,
  AppBar,
  makeStyles,
  IconButton,
  Toolbar,
  Typography,
  Paper,
} from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";
import Alert from "@material-ui/lab/Alert";
import moment from "moment-timezone";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { useDispatch, useSelector } from "react-redux";
import { fetchRequest, reset } from "../../redux/actions/fetch/fetchActions";
import { ObtenerRuleRegExp } from "../../utils/OcrRules";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import { text } from "../../utils/Multilanguage";
import config from "../../config";
import getCurrentPositionAsync from "../../utils/Geolocation";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
    backgroundColor: "#808080",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

export default function DialogOcr(props) {
  const [tons, setTons] = useState(null);
  const [ticket, setTicket] = useState(null);
  const [ocrEdit, setOcrEdit] = useState(false);
  const {
    urlTicket,
    urlTons,
    data,
    isOpen,
    handleClose,
    handleCloseAll,
    typeload,
    load,
    jsonticket,
    jsontons,
    image
  } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [error, setError] = useState({
    open: false,
    message: "Error",
  });

  const fetch = useSelector((state) => state.fetch);

  const handleChangeTons = (e) => {
    setOcrEdit(true);
    setTons(e.target.value);
  };
  const handleChangeTicket = (e) => {
    setOcrEdit(true);
    setTicket(e.target.value);
  };

  const handleConfirm = async () => {
    let data = null;

    if (+tons === 0) {
      setError({
        open: true,
        message: "Tons: Must be greater than 0",
      });
    } else if (+tons > 30) {
      setError({
        open: true,
        message: "Tons: Must be less than or equal to 30",
      });
    } else {
      setError({
        open: false,
        message: "Error",
      });

      const { latitude, longitude } = await getCurrentPositionAsync();

      let formData = new FormData();
      formData.append("tripId", load.id);
      formData.append("type", typeload === 1 ? "PICKUP" : "DELIVERY");
      formData.append("image", image);
      formData.append("ticketCoordination", JSON.stringify(jsonticket));
      formData.append("tonsCoordination", JSON.stringify(jsontons));
      formData.append("ticket", ticket);
      formData.append("tons", tons);
      formData.append("ocrEdit", ocrEdit);
      formData.append("signTime", moment.tz(new Date(), "America/Chicago").format("YYYY-MM-DD HH:mm:ss"));
      formData.append("lat", latitude);
      formData.append("lng", longitude);

      const authKey = localStorage.getItem("key");

      const url = `${config.API_URL}services/app/Trip/UpdateTicketOcr?key=${authKey}`
      const token = localStorage.getItem("token");
      const options = {
        headers: {
          'Content-Type': 'multipart/form-data',
          accept: 'application/json',
          Authorization: `Bearer ${token}`,
          "Abp.Tenantid": config.TENANT_ID
        }
      }

      dispatch(
        fetchRequest(
          url,
          formData,
          options,
          "POST"
        )
      );
    }
  };

  useEffect(() => {
    if (data != null) {
      setTons(data.tons);
      setTicket(data.ticket);
    }
  }, [data]);

  useEffect(() => {
    if (fetch.error !== null) {
      setError({
        open: true,
        message: fetch.error,
      });
      dispatch(reset());
    }
  }, [fetch.error]);

  return (
    <Dialog fullScreen open={isOpen} onClose={handleClose}>
      <AppBar className={classes.appBar}>
        <Toolbar>
          <Typography variant='h4' className={classes.title}>
            OCR
          </Typography>
        </Toolbar>
      </AppBar>
      <div>
        <div className='button' style={{ display: "flex" }}>
          <IconButton
            aria-label='delete'
            style={{ color: "green" }}
            onClick={handleConfirm}
          >
            <CheckCircleIcon fontSize='large' />
          </IconButton>
          <IconButton
            aria-label='delete'
            style={{ color: "red", position: "absolute", right: "0px" }}
            onClick={handleCloseAll}
          >
            <CancelIcon fontSize='large' />
          </IconButton>
        </div>
        <Paper
          style={{
            textAlign: "center",
            border: "1px solid",
            margin: "10px",
            background: "darkgray",
          }}
        >
          <h4 style={{ marginTop: "2px" }}>Ticket #</h4>
          <img
            src={urlTicket}
            alt='ticket'
            style={{ width: "80%", maxHeight: "110px" }}
          />
          <input
            type='text'
            value={ticket}
            onChange={handleChangeTicket}
            style={{
              width: "80%",
              marginTop: "10px",
              border: "1px solid",
              background: "white",
              textAlign: "center",
              fontSize: "x-large",
            }}
          />
        </Paper>

        <Paper
          style={{
            textAlign: "center",
            border: "1px solid",
            margin: "10px",
            background: "darkgray",
          }}
        >
          <h4 style={{ marginTop: "2px" }}>Tons</h4>
          <img
            src={urlTons}
            alt='ticket'
            style={{ width: "80%", maxHeight: "110px" }}
          />
          <input
            type='number'
            value={tons}
            onChange={handleChangeTons}
            inputMode='decimal'
            style={{
              width: "80%",
              marginTop: "10px",
              border: "1px solid",
              background: "white",
              textAlign: "center",
              fontSize: "x-large",
            }}
          />
        </Paper>
        {error.open && (
          <Alert variant='filled' severity='error' style={{ margin: "10px" }}>
            {text(error.message)}
          </Alert>
        )}
        <LoadingSpinner isLoading={fetch.loading} />
      </div>
    </Dialog>
  );
}
